"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationId;
(function (NotificationId) {
    NotificationId["CustomMarkContextMenuClicked"] = "custom-mark-context-menu-clicked";
    NotificationId["ContextMenuClick"] = "context-menu-click";
    NotificationId["CustomViewRemoved"] = "custom-view-removed";
    NotificationId["CustomViewSaved"] = "custom-view-saved";
    NotificationId["CustomViewSetDefault"] = "custom-view-set-default";
    NotificationId["CustomViewsLoaded"] = "custom-views-loaded";
    NotificationId["DashboardLayoutChanged"] = "dashboard-layout-changed";
    NotificationId["EditButtonClicked"] = "edit-button-clicked";
    NotificationId["EditInDesktopButtonClicked"] = "edit-in-desktop-button-clicked";
    NotificationId["ExtensionDialogUpdate"] = "extension-dialog-update";
    NotificationId["FilterChanged"] = "filter-changed";
    NotificationId["FirstVizSizeKnown"] = "first-viz-size-known";
    NotificationId["FirstPulseMetricSizeKnown"] = "first-pulse-metric-size-known";
    NotificationId["ParameterChanged"] = "parameter-changed";
    NotificationId["PulseError"] = "pulse-error";
    NotificationId["PulseFiltersChanged"] = "pulse-filters-changed";
    NotificationId["PulseInsightDiscovered"] = "pulse-insight-discovered";
    NotificationId["PulseInteractive"] = "pulse-interactive";
    NotificationId["PulseTimeDimensionChanged"] = "pulse-time-dimension-changed";
    NotificationId["PulseUrlChanged"] = "pulse-url-changed";
    NotificationId["SelectedMarksChanged"] = "selected-marks-changed";
    NotificationId["SettingsChanged"] = "settings-changed";
    NotificationId["SummaryDataChanged"] = "summary-data-changed";
    NotificationId["TestConversionNotification"] = "test-conversion-notification";
    NotificationId["ToolbarStateChanged"] = "toolbar-state-changed";
    NotificationId["VizInteractive"] = "viz-interactive";
    NotificationId["AskDataInteractive"] = "ask-data-interactive";
    NotificationId["WorkbookReadyToClose"] = "workbook-ready-to-close";
    NotificationId["WorkbookFormattingChanged"] = "workbook-formatting-changed";
    NotificationId["WorkbookPublished"] = "workbook-published";
    NotificationId["WorkbookPublishedAs"] = "workbook-published-as";
    NotificationId["WorksheetFormattingChanged"] = "worksheet-formatting-changed";
    NotificationId["UrlAction"] = "url-action";
    NotificationId["TabSwitched"] = "tab-switched";
    NotificationId["StoryPointSwitched"] = "story-point-switched";
    NotificationId["ReadyToReceiveAuthToken"] = "ready-to-receive-auth-token";
})(NotificationId = exports.NotificationId || (exports.NotificationId = {}));
//# sourceMappingURL=Notifications.js.map